// How a close was created: a user applying a close template directly, or
// the automatic recurrence occurrence apply job.
export enum CloseApplicationType {
    MANUAL = "manual",
    AUTOMATIC = "automatic",
}

export const applicationTypeLabels: Record<CloseApplicationType, string> = {
    [CloseApplicationType.MANUAL]: "Manual",
    [CloseApplicationType.AUTOMATIC]: "Automatic",
};
